export default function isSvgSrcImageUtil (src) {
  if (!src) {
    return false
  }
  return src.endsWith('.svg')
}
